import { render, staticRenderFns } from "./ProfilePolls.vue?vue&type=template&id=514350e2"
import script from "./ProfilePolls.vue?vue&type=script&lang=js"
export * from "./ProfilePolls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports